<template>
  <div class="products-and-footer">
    <machines></machines>
    <hr>
    <bigankiseries></bigankiseries>
    <hr>
    <swseries></swseries>
    <hr>
    <plseries></plseries>
    <hr>
    <acseries></acseries>
    <hr>
    <hmseries></hmseries>
    <hr>
    <drmedicseries></drmedicseries>
    <hr>
    <kilominus></kilominus>
    <hr>
    <!-- <sunkissedseries></sunkissedseries> -->
    <scfooter></scfooter>
  </div>
</template>

<script>
 export default {
   name: 'products',
   components: {
     machines: () => import('../components/Machines.vue'),
     swseries: () => import('../components/SWseries.vue'),
     plseries: () => import('../components/PLseries.vue'),
     acseries: () => import('../components/ACseries.vue'),
     hmseries: () => import('../components/HMseries.vue'),
     sunkissedseries: () => import('../components/SUNKISSEDseries.vue'),
     bigankiseries: () => import('../components/BigankiSeries.vue'),
     drmedicseries: () => import('../components/DrMedicSeries.vue'),
     kilominus: () => import('../components/KiloMinus.vue'),
     scfooter: () => import('../components/scFooter.vue')
   },
 }
</script>

<style lang="scss" scoped>
 $page-width: 960px;
 @media (min-width: 601px) {
   .products-and-footer {
     margin-top: 80px; /* to deal with floating menu*/
   }
 }


</style>
